import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import TwoRowErrorPage from 'shared/ErrorPages/TwoRowErrorPage'
import ROUTE_KEYS from 'shared/utils/routeKeys'
import useStyles from 'shared/hooks/useStyle'

import styles from './AssetNotApplicableErrorPage.style'

const AssetNotApplicableErrorPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const classes = useStyles(styles)

    const onOk = useCallback(() => {
        navigate(ROUTE_KEYS.MAIN)
    }, [navigate])

    return (
        <TwoRowErrorPage
            message={t('CANCELLED_PROCESS')}
            iconPath="skycenter/not_working_robot.svg"
            iconAlt="error"
        >
            <Button
                data-testid="ok-button"
                css={classes.button}
                onClick={onOk}
            >
                {t('OK')}
            </Button>
        </TwoRowErrorPage>
    )
}

export default AssetNotApplicableErrorPage
